import React from 'react';
import { FormatCurrency } from '@css-xp/ppc-common';

interface AccountBalanceDataProps {
  customerBalances: { [key: string]: number };
}

export const AccountBalanceData = ({ customerBalances }: AccountBalanceDataProps) => {
  const currencyWithBalance = Object.keys(customerBalances).filter(
    (currencyKey) => typeof customerBalances[currencyKey] === 'number'
  );
  if (currencyWithBalance?.length > 0) {
    return (
      <div className="account-balance-data">
        {currencyWithBalance?.map((currency, index) => (
          <div key={`currency-${currency}-${index}`} data-testid={`currency-${currency}-${index}`}>
            <FormatCurrency
              value={Math.abs(customerBalances[currency])}
              currency={currency?.toUpperCase()}
              showCurrencyCode
              showCommas
            />
          </div>
        ))}
      </div>
    );
  }
  return <>USD 0.00</>;
};
